import { IGetFuncionariosAprovadoresDropDownUseCase } from "../../../presentation/useCases/read/get_funcionarios_aprovadores_drop_down_use_case";
import { FuncionarioAprovacaoDropDown } from "../../models/funcionario_aprovacao";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetFuncionariosAprovadoresDropDownUseCase
 */

export class GetFuncionariosAprovadoresDropDownUseCase implements IGetFuncionariosAprovadoresDropDownUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getFuncionariosAprovadoresDropDown(
  ): Promise<FuncionarioAprovacaoDropDown[]> {
    return await this.repository.getFuncionariosAprovadoresDropDown();
  }
}
